// eslint-disable-next-line import/no-relative-packages
import { createTRPCReact } from '@trpc/react-query';

// eslint-disable-next-line import/no-relative-packages
import type { AppRouter } from '../../../universal-dashboard-api/src/summary-api/Routers';

export const trpc = createTRPCReact<AppRouter>();
